import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import useBookableService from "../../api/services/useBookableService";
import useStandService from "../../api/services/useStandService";
import ProfileStatus from "../../components/ProfileStatus/ProfileStatus";
import Loading from "../../components/Loading/Loading";
import StandOccupancy from "../../components/StandOccupancy/StandOccupancy";
import BookingsContainer from "../../components/BookingsContainer/BookingsContainer";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";
import useManager from "../../hooks/useManager";

const UserStandManager = () => {

  const [isLoading, setIsLoading] = useState(true)
  const [stand, setStand] = useState(null)
  const [bookings, setBookings] = useState(null)
  const [isLoadingBookings, setIsLoadingBookings] = useState(false)
  const today = new Date()
  const nextYear = new Date()
  nextYear.setFullYear(today.getFullYear() + 1)
  const [dates, setDates] = useState([today, nextYear])
  const {showBookableRangeBookings} = useBookableService()
  const standService = useStandService()
  const {standId} = useParams()
  const {createDateRange} = useManager()

  useEffect(() => {
    standService.userShowManager(
      (stand) => {
        setStand(stand)
        handleCalendarChange([today, nextYear])
        setIsLoading(false)
      },
      (error) => {
        console.log('validation errors', error)
        //todo do something
        setIsLoading(false)
      },
      standId
    )
  }, [])

  /**
   *
   * @param dates
   */
  const handleCalendarChange = (dates) => {
    setDates(dates)
    if (dates.length === 2) {
      setIsLoadingBookings(true)
      showBookableRangeBookings(
        (bookings) => {
          setBookings(bookings)
          setIsLoadingBookings(false)
        },
        (error) => {
          setIsLoadingBookings(false)
        },
        'stand',
        standId,
        typeof dates[0].toDate === "function" ? dates[0].toDate() : dates[0],
        typeof dates[1].toDate === "function" ? dates[1].toDate() : dates[1],
      )
    }
  }

  return (
    <div className="component-stand-manager">
      <div className="row">
        <div className="col">
          <h1>Stand/Truck/Act beheer</h1>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup
            location="/user/stand/{id}/manager"
          />
        </div>
      </div>

      {isLoading ?
        <Loading/>
        :
        <>
          {stand &&
            <>
              stand/truck/act: {stand.label}
              <ProfileStatus
                model={stand}
                showSettingButton={true}
              />
              <h3>Beschikbaarheid komend jaar</h3>
              <StandOccupancy
                stand={stand}
                createDateRange={createDateRange}
              />
              <br/>
              <br/>
              <BookingsContainer
                bookings={bookings}
                handleCalendarChange={handleCalendarChange}
                dates={dates}
                setDates={setDates}
                isLoading={isLoadingBookings}
              />
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
            </>
          }
        </>
      }

    </div>
  )
}

export default UserStandManager
